import { render, staticRenderFns } from "./EmbeddedListQuestion.vue?vue&type=template&id=0d18ab1a&scoped=true&"
import script from "./EmbeddedListQuestion.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedListQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedListQuestion.vue?vue&type=style&index=0&id=0d18ab1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18ab1a",
  null
  
)

export default component.exports